import { apiPost, type ApiResponse } from "@/lib/api";
import type { TugBrief, TugJudge } from "@/lib/types";

export interface TugWriteInput {
  subject: string;
  team_a: string;
  team_b: string;
  host_team: string;
  limit_cnt: number;
  limit_min: number;
  tap_sec: number;
  judge_mode: TugJudge;
  /** 팀 인원차 허용치. 0 이면 제한 없음 (기본 1) */
  balance: number;
  reward?: string;
}

// 참가 응답 data
// 마감 전: { team, team_name, taps, a_cnt, b_cnt, closed:0 }
// 내가 마지막 자리를 채웠으면 closed:1 과 함께 결과가 그 자리에서 온다.
export interface TugPlayResult {
  team?: string;
  team_name?: string;
  taps?: number;
  a_cnt?: number;
  b_cnt?: number;
  closed?: number;
  win_team?: string;
  win_name?: string;
  [key: string]: unknown;
}

// 등록 (등록자가 자기 팀을 정하고, 등록 후 바로 두드리기 화면으로 넘어간다)
export function writeTug(input: TugWriteInput): Promise<ApiResponse<TugBrief>> {
  return apiPost<TugBrief>("tug_write.php", { act: "write", ...input });
}

// 등록자 조기 종료 → 결과 즉시 공개
export function closeTug(no: number): Promise<ApiResponse<unknown>> {
  return apiPost<unknown>("tug_write.php", { act: "close", no });
}

// 등록자 삭제 (참가자가 있으면 서버가 거절)
export function deleteTug(no: number): Promise<ApiResponse<unknown>> {
  return apiPost<unknown>("tug_write.php", { act: "del", no });
}

// 참가 (팀 선택 + 터치수 제출을 한 번에. 20초 게임이 끝난 뒤 최종 숫자만 보낸다)
export function playTug(
  no: number,
  team: string,
  taps: number
): Promise<ApiResponse<TugPlayResult>> {
  return apiPost<TugPlayResult>("tug_play.php", { no, team, taps });
}